import CompleteSectionForm from '@Components/CompleteSectionForm/CompleteSectionForm';
import {
  enabledProductInfoCompletedSectionEn,
  enabledProductInfoCompletedSectionTh,
} from '@Router/NatureOfBusiness/completedSectionUtils';
import { useWatch } from 'react-hook-form';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { Role } from 'src/Enum/Report';

const ProductionInformationFormCompleteCheckbox = () => {
  const { isPublished } = useProgressBar();
  const productInformation = useWatch({ name: 'productInformation' });

  const completedSection = useWatch({
    name: `productInformation.completedSection`,
  });
  const { setValue } = useNatureOfBusinessForm();

  return (
    <>
      <CompleteSectionForm
        checkSectionName="productInformation.completedSection"
        enableCheckSectionTh={
          !isPublished &&
          enabledProductInfoCompletedSectionTh(productInformation)
        }
        enableCheckSectionEn={
          !isPublished &&
          enabledProductInfoCompletedSectionEn(productInformation)
        }
        onCompleteThChange={(checked) => {
          if (!checked) {
            setValue('productInformation.completedSection', {
              ...completedSection,
              isCompletedTh: false,
              roleStampTh: Role.NONE,
              dateTh: undefined,
            });
          }
        }}
        onCompleteEnChange={(checked) => {
          if (!checked) {
            setValue('productInformation.completedSection', {
              ...completedSection,
              isCompletedEn: false,
              roleStampEn: Role.NONE,
              dateEn: undefined,
            });
          }
        }}
      />
    </>
  );
};
export default ProductionInformationFormCompleteCheckbox;
